<template>
	<div class="component">
		<van-action-sheet v-model="show" title="选择客户">
			<div class="content" style="color: #818181;">
				<div style="padding: 0 var(--base-px-16);">
					全部（{{ user.length }}）
				</div>
				<van-search style="padding: var(--base-px-5) var(--base-px-16)" @clear="$show" v-model="serchValue"
				            placeholder="请输入搜索关键词" @search="search"/>

				<div class="user-list">
					<van-radio-group v-if="user.length > 0" icon-size="15px" v-model="radio">
						<div v-for="(item,index) in user" :key="index" :class="{'active-background':  radio == item.id }"
						     class="user" style="padding: var(--base-px-10) var(--base-px-16);">
							<div>
								<img :src="item.avatar">
								{{ item.name }}
							</div>
							<van-radio :name="item.id"></van-radio>
						</div>
					</van-radio-group>
					<van-empty
						v-else
						class="custom-image"
						:image="require('../../../assets/images/mobiletodo.png')"
						description="暂无客户"
					/>
				</div>
				<van-button @click="determine" block
				            style="width: 90%;margin: 0 auto;margin-top: var(--base-px-10);margin-bottom: var(--base-px-10)"
				            type="info">确定
				</van-button>
			</div>
		</van-action-sheet>
	</div>
</template>

<script>
import {getContact} from '../../../api/homePage'

export default {
	data() {
		return {
			show: false,
			radio: '',
			// 搜索名称
			serchValue: '',
			user: []
		}
	},
	watch: {},
	methods: {
		$show() {
			this.show = true
			getContact().then(res => {
				this.user = res.data
			})
		},
		determine(e) {
			if (!this.radio) {
				Toast.fail('请选择客户');
			}
			const data = this.user.filter(item => {
				return item.id == this.radio
			})
			this.$emit("change", data)
			this.show = false
			// this.radio = ''
		},
		search(e) {
			getContact({name: e}).then(res => {
				this.user = res.data
			})
		}

	}
}
</script>

<style lang="less" scoped>
/deep/ .van-action-sheet__header {
	font-weight: bolder;
}

.component {
	.content {
		padding: 0;

		.user-list {
			height: var(--base-px-275);
			overflow: auto;

			.user {
				display: flex;
				align-items: center;
				justify-content: space-between;

				div {
					font-size: var(--base-px-14);
					color: #252528;

					img {
						width: var(--base-px-46);
						height: var(--base-px-46);
						margin-right: var(--base-px-6);
					}
				}
			}

			.active-background {
				background: #f6fbff !important;
			}
		}
	}
}
</style>
